export default __webpack_public_path__ + "static/media/logo-removebg.89642f1b.png";